export enum MediaUrlType {
  Image = "image",
  Video = "video",
}
